import { render, staticRenderFns } from "./intervention.vue?vue&type=template&id=61080b21&scoped=true&"
import script from "./intervention.vue?vue&type=script&lang=js&"
export * from "./intervention.vue?vue&type=script&lang=js&"
import style0 from "./intervention.vue?vue&type=style&index=0&id=61080b21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61080b21",
  null
  
)

export default component.exports